import { useLocation } from "react-router-dom";
import { useNotifications } from "../../contexts/NotificationsContext";

export const NOTIFICATIONS_INBOX_PATH = "/alpha/notifications";

export interface NotificationBellState {
  visible: boolean;
  to: string;
  /** Text for the count pill, or null when no pill should render. */
  pillText: string | null;
  ariaLabel: string;
  isCurrent: boolean;
}

export function formatUnreadPill(count: number | null): string | null {
  if (count === null || count <= 0) return null;
  return count >= 100 ? "99+" : String(count);
}

export function unreadAriaLabel(count: number | null): string {
  if (count === null || count <= 0) return "Notifications";
  if (count >= 100) return "Notifications, more than 99 unread";
  return `Notifications, ${count} unread`;
}

/** Shared bell logic for every shell; the destination is always the Alpha inbox. */
export function useNotificationBell(): NotificationBellState {
  const { enabled, unreadCount } = useNotifications();
  const location = useLocation();
  return {
    visible: enabled,
    to: NOTIFICATIONS_INBOX_PATH,
    pillText: formatUnreadPill(unreadCount),
    ariaLabel: unreadAriaLabel(unreadCount),
    isCurrent: location.pathname === NOTIFICATIONS_INBOX_PATH,
  };
}
